
        <div class="new-order-inputs-container">

            <div class="om-search-bar">
                <div class="om-search-content">
                    <input class="om-search-text" [(ngModel)]="searchValue" placeholder="Search..." type="text" (ngModelChange)="searchOrders()">
                    <img src="../../../../../assets/order-to-cash-icons/search.svg" alt="Search Icon" class="om-search-icon">
                </div>
            </div>


            <div class="om-spacer-reset-container">
                <button mat-button="outlined" style="margin-right: 10px;" class="reset-filter-btn" (click)="resetFilter()" *ngIf="isFilterBtnVisible">Clear Filters</button>
            </div>

            <button class="filtering-btn" mat-flat-button type="button" (click)="openFilterDialog()">
                <div class="filtering-content">
                    <img src="../../../../../assets/order-to-cash-icons/tune-filter.svg" alt="Filter Icon" class="filtering-icon">
                    <span><p class="filtering-text">Filtering</p></span>
                </div>
            </button>
        </div>

        <div class="my-order-table-container">

            <section class="my-order-table-section">

                <table mat-table [dataSource]="dataSource" class="my-order-table">

                    <ng-container matColumnDef="agentName">
                        <th mat-header-cell *matHeaderCellDef class="my-order-top-left-cell"> Agent Name </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element?.repName ?? placeholder}} </td>
                    </ng-container>

                    <ng-container matColumnDef="orderId">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Order Id </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element?.displayOrderNumber ?? element?.orderNumber ?? placeholder}} </td>
                    </ng-container>

                    <ng-container matColumnDef="orderDate">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Order Date </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element.orderDate ? dayjs(element.orderDate).format(dateStingFormatting) : placeholder}}  </td>
                    </ng-container>

                    <ng-container matColumnDef="clientName">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Client </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element?.clientName ?? placeholder}} </td>
                    </ng-container>

                    <ng-container matColumnDef="orderValue">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Order Value </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{(element?.totalPrice | currency:'R':'symbol':'1.0-2') ?? placeholder}} </td>
                    </ng-container>

                    <ng-container matColumnDef="maxDiscount">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Max Discount </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text"> {{element?.maxDiscount  ? element.maxDiscount + '%' : placeholder}} </td>
                    </ng-container>

                    <ng-container matColumnDef="orderStatus">
                        <th mat-header-cell *matHeaderCellDef class="my-order-th-cell"> Status </th>
                        <td mat-cell *matCellDef="let element" class="my-order-td-cell my-order-table-text">
                            <span  [ngClass]="{
                                            'status-draft': element.orderStatus === 'Draft',
                                            'status-submitted': element.orderStatus === 'Submitted',
                                             'status-submitted-sap': element.orderStatus === 'Submitted to SAP',
                                             'status-pending-manager-approval': element.orderStatus === 'Pending Manager Approval',
                                            'status-rejected': element.orderStatus === 'Rejected',
                                            'status-approved': element.orderStatus === 'Approved',
                                            'status-client-approval': element.orderStatus === 'Client Approval',
                                            'status-client-rejected': element.orderStatus === 'Client Rejected',
                                            'status-submit-sap-failed': element.orderStatus === 'SAP Submission Failed',
                                            'status-edit-after-submit-to-sap': element.orderStatus === 'Submitted Update to SAP',
                                            'status-submitted-update-to-sap': element.orderStatus === 'Edit After SAP Submission',
                                            'status-pending-term-manager-approval': element.orderStatus === 'Pending Term Manager Approval',
                                          }">
                                 {{element?.orderStatus ?? placeholder}}
                            </span>    
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="my-order-top-right-cell"></th>
                        <td mat-cell *matCellDef="let element" class="my-order-top-right-cell">
                            <img src="../../../assets/icons/chevron_right.svg" alt="Arrow Right Icon"  (click)="reviewOrder(element.id)">
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="reviewOrder(row.id)"></tr>
                </table>
            </section>

            <div *ngIf="isNoItemsFound" class="my-order-no-items-message-container">
                <div class="my-order-no-items-message">Sorry! No items found within the selected filter range.</div>
            </div>
            <div class="my-order-paginator-container-my-orders">
                <mat-paginator
                               (page)="onPaginateChange($event)"
                               [pageSize]="pageSize"
                               [pageIndex]="currentPage"
                               [pageSizeOptions]="[5, 10, 20, 50, 100]"
                               [showFirstLastButtons] = "true"
                               [length]="totalElements"
                               >
                </mat-paginator>
            </div>

        </div>
